import { FC } from "react";
import ListItem from "./ListItem";
import styles from "./searchResultList.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const SearchResultList: FC<any> = ({
  selectedIndex,
  getItemProps,
  items,
}: {
  selectedIndex: any;
  getItemProps: any;
  items: any;
}) => {
  const resultList = items?.length
    ? items?.map((item: any) => {
        const type = item?.type;

        let icon = "icon-distance";
        if (type === "establishment") {
          icon = "icon-search-university";
        } else if (type === "inventory") {
          icon = "icon-search-inventory";
        }

        return { ...item, icon };
      })
    : [];

  return resultList?.length > 0 ? (
    <div className={styles.outerResultContainer}>
      <div className={styles.resultListContainer}>
        {resultList.map((item: any, index: any) => (
          <ListItem
            key={index}
            index={index}
            selectedIndex={selectedIndex}
            data={item}
            getItemProps={getItemProps}
          />
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default wrapperHOC(SearchResultList, {
  componentName: "SearchResultList-SearchModalDesktop-Global",
  showForChina: true,
});
